import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Circle, Defs, LinearGradient, Path, Stop } from '../base/Icon';
import type { BaseIconProps } from '../types';

// Official Google Chrome icon (February 2022) from Wikimedia Commons
const Chrome: React.FC<BaseIconProps> = t0 => {
  const $ = _c(11);
  const {
    size: t1,
    width,
    height
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const iconWidth = width || size;
  const iconHeight = height || size;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LinearGradient id="ch-a" x1="3.2173" y1="15" x2="44.7812" y2="15" gradientUnits="userSpaceOnUse"><Stop offset="0" stopColor="#d93025" /><Stop offset="1" stopColor="#ea4335" /></LinearGradient>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LinearGradient id="ch-b" x1="20.7219" y1="47.6791" x2="41.5039" y2="11.6837" gradientUnits="userSpaceOnUse"><Stop offset="0" stopColor="#fcc934" /><Stop offset="1" stopColor="#fbbc04" /></LinearGradient>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Defs>{t2}{t3}<LinearGradient id="ch-c" x1="26.5981" y1="46.5015" x2="5.8161" y2="10.506" gradientUnits="userSpaceOnUse"><Stop offset="0" stopColor="#1e8e3e" /><Stop offset="1" stopColor="#34a853" /></LinearGradient></Defs>;
    t5 = <Circle cx="24" cy="23.9947" r="12" fill="#fff" />;
    t6 = <Path d="M24,12H44.7812a23.9939,23.9939,0,0,0-41.5639.0029L13.6079,30l.0093-.0024A11.9852,11.9852,0,0,1,24,12Z" fill="url(#ch-a)" />;
    t7 = <Circle cx="24" cy="24" r="9.5" fill="#1a73e8" />;
    t8 = <Path d="M34.3913,30.0029,24.0007,48A23.994,23.994,0,0,0,44.78,12.0031H23.9989l-.0025.0093A11.985,11.985,0,0,1,34.3913,30.0029Z" fill="url(#ch-b)" />;
    t9 = <Path d="M13.6086,30.0031,3.218,12.006A23.994,23.994,0,0,0,24.0025,48L34.3931,30.0029l-.0067-.0068a11.9852,11.9852,0,0,1-20.7778.007Z" fill="url(#ch-c)" />;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
  } else {
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
    t7 = $[5];
    t8 = $[6];
    t9 = $[7];
  }
  let t10;
  if ($[8] !== iconHeight || $[9] !== iconWidth) {
    t10 = <Icon width={iconWidth} height={iconHeight} viewBox="0 0 48 48" fill="none">{t4}{t5}{t6}{t7}{t8}{t9}</Icon>;
    $[8] = iconHeight;
    $[9] = iconWidth;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
};
export default Chrome;